import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as UserDataConfig from '../../config/user-data.config';
import { AnalyticsService, FormValidationsService, AnnuitantDetailService, SERVICE_END_POINT, AuthService } from '../../../../shared';
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { UtilService } from '../../../../shared';
import { CmsService } from 'src/app/core/cms/service.service';
import * as yourPersonalDetailsActions from '../../../../store/actions/your-personal-details.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { YourPersonalDetails } from 'src/app/model/ngrx/your-personal-details.model';
import { EmailMatch } from 'src/app/shared/validators/email-match.validators';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-your-personal-details',
  templateUrl: './your-personal-details.component.html',
  styleUrls: ['./your-personal-details.component.scss']
})
export class YourPersonalDetailsComponent implements OnInit, OnDestroy {

  yourPersonalDetailForm: UntypedFormGroup;

  public afterApplyDetail = UserDataConfig.ElementsConfig;
  public titleConfig = this.afterApplyDetail.titleConfig;
  protected forenameTextCodeConfig = this.afterApplyDetail.forenameTextConfig;
  protected surnameTextCodeConfig = this.afterApplyDetail.surnameTextConfig;
  protected middleNameTextCodeConfig = this.afterApplyDetail.middleNameTextConfig;
  protected thirdNameTextCodeConfig = this.afterApplyDetail.thirdNameTextConfig;
  public emailTextCodeConfig = this.afterApplyDetail.emailTextConfig;
  public mobilePhoneCodeConfig = this.afterApplyDetail.mobilePhoneConfig;
  public homePhoneCodeConfig = this.afterApplyDetail.homePhoneConfig;
  public ninoCodeConfig = this.afterApplyDetail.ninoConfig;
  protected contactPrefCodeConfig;

  public confirmEmailTextCodeConfig = this.afterApplyDetail.confirmEmailTextConfig;
  public forenameData: string = '';
  public surnameData: string = '';
  public middleNameData: string = '';
  public thirdNameData: string = '';
  public dateOfBirthData: string = '';
  public genderData: string = '';
  public maritalStatusData: string = '';
  public maritalStatusDataCode: string = '';
  public addressLine1Data: string = '';
  public addressLine2Data: string = '';
  public addressLine3Data: string = '';
  public addressLine4Data: string = '';
  public postCodeData: string = '';
  protected ninoData: string = null;
  protected otherTitleData = [];
  protected otherTitleList: any;
  enableOtherTitle: boolean = false;
  public otherTitle = [];
  public array1 = [];
  CMSData;
  loggedinDetailsStore: Observable<any[]>;
  yourPersonalDetailsStore: Observable<YourPersonalDetails[]>;
  loggedinDetails: any;
  yourPersonalDetails: YourPersonalDetails;
  loggedinDetailsStoreSubscription: Subscription;
  yourPersonalDetailsStoreSubscription: Subscription;
  subscripSaveProgress: Subscription;
  subscriptn: Subscription;
  subscripLogout: Subscription;

  contentData;
  storeFlag: boolean = false;


  responseApplicationData: any;

  @ViewChild('anchorBlur', { static: true }) anchorBtn: ElementRef;

  constructor(
    // Constructor to inject Dependency injections
    private router: Router,
    private fb: UntypedFormBuilder,
    private cmsService: CmsService,
    private activatedRoute: ActivatedRoute,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private annuitantService: AnnuitantDetailService,
    private analyticsService: AnalyticsService,
    public el: ElementRef,
    private store: Store<AppState>,
    private utilService: UtilService, private authService: AuthService) {

    this.contentData = this.activatedRoute.snapshot.data.contentData.yourPersonalDetails;
    this.contactPrefCodeConfig = this.contentData.contactPrefConfig;

    // this.yourPersonalDetailsStore = store.select('yourPersonalDetails');
    this.yourPersonalDetailsStoreSubscription = store.select(STORE_VAL.your_personal_details).subscribe(val => {
      console.log('--val-', val);
      if (val && val.length > 0) {
        this.yourPersonalDetails = val[0];
        //console.log(this.yourPersonalDetails);
      }
      this.mobilePhoneCodeConfig.value = (this.yourPersonalDetails && this.yourPersonalDetails.mobilePhone) ? this.yourPersonalDetails.mobilePhone : null;
      this.homePhoneCodeConfig.value = (this.yourPersonalDetails && this.yourPersonalDetails.homePhone) ? this.yourPersonalDetails.homePhone : null;
    });

    this.loggedinDetailsStore = store.select(STORE_VAL.loggedin_detail);
    this.loggedinDetailsStoreSubscription = this.loggedinDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        //console.log('call subscribe');
        this.loggedinDetails = val[0];
      }
    });

    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataService();
    // OnInit-> To initialize and load the form and other fields
    // this.getOtherTitleData();
    this.prepareStoreDataANDsetValues();
    this.subscripSaveProgress = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.yourPersonalDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }

  saveProgress() {
    // Onclick of Save Progress button logic
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    // Onclick of Logout button logic
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }

  prepareStoreDataANDsetValues() {
    // To set the values from either of the store dynamically
    let storeData: YourPersonalDetails;
    let contactPref: string;
    if (this.yourPersonalDetails) {
      storeData = this.yourPersonalDetails;
      // contactPref = this.yourPersonalDetails.contactPref;
      this.storeFlag = false;
    } else {
      storeData = this.loggedinDetails ? this.loggedinDetails.customer : null;
      // contactPref = null;
      this.storeFlag = true;
    }
    // Fix Title From HO
    if (storeData && storeData.title &&
      storeData.title !== '' &&
      storeData.title !== 'Other' &&
      storeData.title !== 'Mr' &&
      storeData.title !== 'Miss' &&
      storeData.title !== 'Mrs' &&
      storeData.title !== 'Ms' &&
      storeData.title !== 'Mx' &&
      storeData.title !== 'Doctor') { // Title others
      storeData['otherTitle'] = storeData.title;
      storeData.title = 'Other';
    }
    if( this.titleConfig &&  this.titleConfig.options.length > 0 && storeData.title === 'Other') {
      if(this.titleConfig.options.filter(val => val['value'] == storeData.otherTitle).length == 1) {
        storeData.title = storeData.otherTitle;
        storeData.otherTitle = '';
      }
    }
   
    this.enableOtherTitle = storeData && storeData.title === 'Other' ? true : false;
    this.getOtherTitle();
    this.userFormData(storeData);
    this.setLoggedin_OR_PersonalDetailsData(storeData, this.storeFlag);
  }

  setLoggedin_OR_PersonalDetailsData(storeData, storeFlag) {
    // Sets the value for readonly fields
    let date = storeData && storeData.dateOfBirth ? storeData.dateOfBirth : '';
    this.dateOfBirthData = (date && date !== '') ? (date.indexOf('/') > -1 ? (date.split('/').join(' / ')) : date) : '';
    this.genderData = storeData && storeData.gender ? (storeData.gender === 'M' ? 'Male' : 'Female') : '';
    this.postCodeData = storeData && storeData.address.postcode ? storeData.address.postcode : '';
    this.ninoData = (storeData && storeData.nino) ? storeData.nino : '';
    this.maritalStatusDataCode = storeData && storeData.maritalStatus ? storeData.maritalStatus : '';
    if (storeData && storeData.maritalStatus && storeData.maritalStatus !== '') {
      switch (storeData.maritalStatus) {
        case 'S': this.maritalStatusData = 'Single';
          break;
        case 'M': this.maritalStatusData = 'Married';
          break;
        case 'CP': this.maritalStatusData = 'Civil partner';
          break;
        case 'CH': this.maritalStatusData = 'Cohabiting';
          break;
        case 'D': this.maritalStatusData = 'Divorced';
          break;
        case 'SE': this.maritalStatusData = 'Separated';
          break;
        case 'W': this.maritalStatusData = 'Widowed';
          break;
        default: this.maritalStatusData = '';
          break;
      }
    } else {
      this.maritalStatusData = '';
    }
    this.forenameData = storeData && storeData.forename ? storeData.forename : '';
    this.surnameData = storeData && storeData.surname ? storeData.surname : '';
    this.middleNameData = storeData && storeData.middleName ? storeData.middleName : '';
    this.thirdNameData = storeData && storeData.thirdName ? storeData.thirdName : '';
    this.addressLine1Data = storeData && storeData.address.line1 ? storeData.address.line1 : '';
    this.addressLine2Data = storeData && storeData.address.line2 ? storeData.address.line2 : '';
    this.addressLine3Data = storeData && storeData.address.line3 ? storeData.address.line3 : '';
    this.addressLine4Data = storeData && storeData.address.line4 ? storeData.address.line4 : '';
  }

  getOtherTitleData() {
    // This method merges static data 'Title' and 'otherTitle' by getting data from service call
    this.annuitantService.getOtherTitle().subscribe(data => {
      this.otherTitleData = data;
      if (this.otherTitleData.length > 0) {
        this.otherTitleData.forEach(val => {
          this.titleConfig.options.push({ value: val.description, code: val.key });
        });
      }
    });
  }

  ngOnDestroy() {
    // OnDestroy unsubscribing the subcriptions
    if (this.loggedinDetailsStoreSubscription) {
      this.loggedinDetailsStoreSubscription.unsubscribe();
    }
    if (this.yourPersonalDetailsStoreSubscription) {
      this.yourPersonalDetailsStoreSubscription.unsubscribe();
    }
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }

  userFormData = (storeData) => {
    // To create and to build the form
    // this.yourPersonalDetailForm = this.fb.group({
    //   title: [(storeData && storeData.title) ? storeData.title : null, [Validators.required]],
    //   otherTitle: [(storeData && storeData.title) ? storeData.title : null],
    //   middleName: [(storeData && storeData.middleName) ? storeData.middleName : '', [Validators]],
    //   thirdName: [(storeData && storeData.thirdName) ? storeData.thirdName : '', [Validators]],
    //   emailAddress: [(storeData && storeData.emailAddress) ? storeData.emailAddress : '', [Validators.required]],
    //   mobilePhone: [(storeData && storeData.mobilePhone) ? storeData.mobilePhone : ''],
    //   homePhone: [(storeData && storeData.homePhone) ? storeData.homePhone : ''],
    //   nino: [(this.yourPersonalDetails && this.yourPersonalDetails.nino) ? this.yourPersonalDetails.nino : '', [Validators.required]],
    //   // contactPref: [(contactPref) ? this.yourPersonalDetails.contactPref : null, Validators.required],
    //   confirmEmailAddress: [(storeData && storeData.emailAddress) ? storeData.emailAddress : '', [Validators.required]]
    //   //country: [this.personDetail.country]
    // },
    //   {
    //     validator: EmailMatch('emailAddress', 'confirmEmailAddress')
    //   }
    // );
    // console.log('---------------------',storeData, this.yourPersonalDetails);
    this.yourPersonalDetailForm = this.fb.group({
        title: [(storeData && storeData.title) ? storeData.title : null, [Validators.required]],
        otherTitle: [(storeData && storeData.title) ? storeData.title : null],
        middleName: new FormControl([(storeData && storeData.middleName) ? storeData.middleName : '' , Validators]),
        thirdName: new FormControl([(storeData && storeData.thirdName) ? storeData.thirdName : '' , Validators]),
        emailAddress: [(storeData && storeData.emailAddress) ? storeData.emailAddress : '', [Validators.required]],
        mobilePhone: [(storeData && storeData.mobilePhone) ? storeData.mobilePhone : ''],
        homePhone: [(storeData && storeData.homePhone) ? storeData.homePhone : ''],
        nino: [(this.yourPersonalDetails && this.yourPersonalDetails.nino) ? this.yourPersonalDetails.nino : '', [Validators.required]],
        // contactPref: [(contactPref) ? this.yourPersonalDetails.contactPref : null, Validators.required],
        confirmEmailAddress: [(storeData && storeData.emailAddress) ? storeData.emailAddress : '', [Validators.required]]
        //country: [this.personDetail.country]
      },
        {
          validator: EmailMatch('emailAddress', 'confirmEmailAddress')
        }
      );
  
    console.log('------------------------', this.yourPersonalDetailForm);
  }

  onBackClick() {
    // OnBackClick this method invokes
    this.saveFormValues();
  }

  saveFormValues() {
    // To save all fields values into the store
    this.store.dispatch(new yourPersonalDetailsActions.RemoveYourPersonalDetails(0));
    this.store.dispatch(new yourPersonalDetailsActions.AddYourPersonalDetails({
      title: this.yourPersonalDetailForm.value.title,
      otherTitle: this.yourPersonalDetailForm.value.otherTitle,
      forename: this.forenameData,
      surname: this.surnameData,
      middleName: this.middleNameData,
      thirdName: this.thirdNameData,
      dateOfBirth: this.dateOfBirthData,
      maritalStatus: this.maritalStatusDataCode,
      // this.getMaritalStatus(this.maritalStatusData)
      gender: this.genderData !== 'Not provided' ? (this.genderData === 'Male' ? 'M' : 'F') : 'Not provided',
      emailAddress: this.yourPersonalDetailForm.value.emailAddress,
      confirmEmailAddress: this.yourPersonalDetailForm.value.confirmEmailAddress,
      address: {
        line1: this.addressLine1Data,
        line2: this.addressLine2Data,
        line3: this.addressLine3Data,
        line4: this.addressLine4Data,
        postcode: this.postCodeData,
      },
      mobilePhone: this.yourPersonalDetailForm.value.mobilePhone,
      homePhone: this.yourPersonalDetailForm.value.homePhone,
      nino: this.ninoData ? this.ninoData : this.yourPersonalDetailForm.value.nino,
      // contactPref: this.yourPersonalDetailForm.value.contactPref
    }));
    //console.log('Stored->', this.yourPersonalDetails);
  }

  // getMaritalStatus(data) {
  //   // To set maritalSatus value
  //   let tempData;
  //   if (data !== 'Not provided') {
  //     switch (data) {
  //       case 'Single': tempData = 'S';
  //         break;
  //       case 'Married': tempData = 'M';
  //         break;
  //       case 'Civil partner': tempData = 'CP';
  //         break;
  //       case 'Cohabiting': tempData = 'CH';
  //         break;
  //       case 'Divorced': tempData = 'D';
  //         break;
  //       case 'Separated': tempData = 'SE';
  //         break;
  //       case 'Widowed': tempData = 'W';
  //         break;
  //       default: tempData = 'Not provided';
  //         break;
  //     }
  //   } else {
  //     tempData = 'Not provided';
  //   }
  //   return tempData;
  // }


  gotoNext() {
    /** Per DTC-292 : checking if the product selected is H or G (FTRP or CORP) then the user has to be navigated to the pension savings page else
     * navigated to the medical records screen
     */
    if (this.yourPersonalDetailForm.valid) {
      this.saveFormValues();
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        // tslint:disable-next-line: max-line-length
        if (this.responseApplicationData.quoteFundInfo[0].productType === 'H' || this.responseApplicationData.quoteFundInfo[0].productType === 'G') {
          this.router.navigate(['/apply/your-pension-savings']);

        } else {
          this.router.navigate(['/apply/your-doctors-details']);
          /** Incase of Product = Pension annuity */
          /** Case 2 - Incase of pension annuity check for spouses benefits according to DTC-292
           * if secondLife is yes , navigate to dependent screen else
           * if secondLife is no/null, navigate to the medical records screen
           */
          // this.saveFormValues();
          // this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
          /*
          if (res.secondLife !== null && res.secondLife.dateOfBirth !== null) {
            // if (res.secondLife.dateOfBirth) {
              this.router.navigate(['/apply/your-dependant-details']);
            // }
          } else {
            this.router.navigate(['/apply/your-doctors-details']);
          }
          */
          // });
        }
      });
    } else {
      //console.log('Not Valid', this.yourPersonalDetailForm);
      FormValidationsService.validateAllFormFields(this.yourPersonalDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
    /**  // Old code
     * // Triggers on click on Next button
     if (this.yourPersonalDetailForm.valid) {
        this.saveFormValues();
        this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
          //console.log("Response from backend", res);
          // Do routing here...!!!
          this.router.navigate(['/apply/your-pension-savings']);
        });
        //console.log('Valid', this.yourPersonalDetailForm);
      } else {
        //console.log('Not Valid', this.yourPersonalDetailForm);
        FormValidationsService.validateAllFormFields(this.yourPersonalDetailForm);
        setTimeout(() => {
          this.scrollInvalidForm();
        }, 0);
    } */
  }

  scrollInvalidForm() {
    // To scroll the page and to show the first occurance of form-field erroe
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  getToggleValue(value) {
    // Adding the custom validation on selectin any values in security question
    //console.log(value);
    if (value === 'T') {
      this.yourPersonalDetailForm.controls['mobilePhone'].setValidators([Validators.required, Validators.pattern("^[0+]\d+(?: ?\d+)*$")]);
      this.mobilePhoneCodeConfig.required = true;
      // this.yourPersonalDetailForm.controls['mobilePhone'].setErrors({ required: true });
    } else {
      this.yourPersonalDetailForm.controls['mobilePhone'].setValidators(Validators.pattern("^[0+]\d+(?: ?\d+)*$"));
      // this.yourPersonalDetailForm.controls['mobilePhone'].setErrors(null);
      this.mobilePhoneCodeConfig.required = false;
    }
  }
  // defect# 2700 other title field must be different field
  getOtherTitle() {
    this.annuitantService.getOtherTitle().subscribe(data => {
      this.otherTitleList = data;
    });
    this.otherTitle = this.array1;
  }
  detectChange() {
    const othTitle = this.yourPersonalDetailForm.get('otherTitle');
    if (this.titleConfig.defaultValue === 'Other') {
      this.enableOtherTitle = true;
      othTitle.setValidators(Validators.required);
      this.getOtherTitle();
    } else {
      this.yourPersonalDetailForm.controls['otherTitle'].setValue(null);
      this.enableOtherTitle = false;
      othTitle.setValidators(null);
      // this.otherTitle=null;
    }
    this.triggerotherTitleValidation();

  }
  triggerotherTitleValidation() {
    this.yourPersonalDetailForm.updateValueAndValidity();
  }
  /** CMS block  */
  GetCMSDataService() {
    //console.log('original value = ');
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPersonalDetailsApply;
    this.utilService.getCMSData(URL)
      .subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.header = this.CMSData.string_ApplyYourPersonalDetailsTitle;
          this.ninoCodeConfig.errorMessage = this.CMSData.string_NationalInsuranceError1;
          this.ninoCodeConfig.errorMessageInvalid = this.CMSData.string_NationalInsuranceError2;
          this.contactPrefCodeConfig.validationMsg = this.CMSData.string_ApplicationUpdateError1;
          this.mobilePhoneCodeConfig.errorMessage = this.CMSData.string_ApplicationUpdateError2;
          this.contactPrefCodeConfig.questionStatement = this.CMSData.string_ApplicationUpdateQuestion;
          this.contentData.subtitle = this.CMSData.string_ApplyYourPersonalDetailsSubTitle1;
          this.contentData.noteStatement = this.CMSData.string_ApplyYourPersonalDetailsSubTitle2;
          // this.contentData.externalURL_UpdateLink = this.CMSData.externalURL_UpdateLink;
          this.contentData.updateText = this.CMSData.string_UpdateMyDetailsText;
          this.mobilePhoneCodeConfig.invalidErrorMessage = this.CMSData.commonBlock.string_PhoneFormatError;
          this.homePhoneCodeConfig.invalidErrorMessage = this.CMSData.commonBlock.string_PhoneFormatError;
          //console.log('changed value = ');
        }
      });
  }
  blurHandler() {
    this.saveFormValues();
    this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
      this.router.navigate(['/home/update-my-details']);
    });
    // this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Privacy policy', pageID: this.getCurrentScreenURL()});
    // this.anchorBtn.nativeElement.blur();
  }

  /** End of code block for CMS */
}


